<template>
  <div
    class="w-full bg-white border border-[#E5E7EB] rounded-xl pt-5 px-5 pb-5 shadow-sm text-left overflow-hidden animate-pulse"
  >
    <div class="h-5 bg-slate-200 rounded w-28 mb-4"></div>

    <div class="relative">
      <div class="absolute left-[4px] top-[10px] bottom-0 w-[2px] bg-slate-200 z-0"></div>

      <div v-for="n in 3" :key="n" class="flex gap-4 relative z-10 mb-3 last:mb-0">
        <div class="relative flex flex-col items-center shrink-0">
          <div class="w-2.5 h-2.5 rounded-full mt-1.5 z-10 bg-slate-200"></div>
        </div>

        <div class="flex flex-col gap-1.5 w-full">
          <div class="flex gap-2">
            <div class="h-4 bg-slate-200 rounded w-20"></div>
            <div class="h-4 bg-slate-200 rounded w-48"></div>
          </div>
          <div class="h-3 bg-slate-200 rounded w-24"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
